import { createSlice } from "@reduxjs/toolkit";

const variableSetSlice = createSlice({
  name: "variableSetSlice",
  initialState: {
    isLoading: false,
    errors: {},
    total: 0,
    totalPages: 0,
    allVariableSets: [],
    selectedVariableSetDetail: {},
    isSaveRequest: false,
    isRefetchEnvironment: false,
    isRefetchCollection: false,
    isRefetchFolder: false
  },
  reducers: {
    updateLoadError: (state, action) => {
      return {
        ...state,
        errors: action.payload.error_message,
      };
    },
    setLoadingState: (state, action) => {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
    setSavingState: (state, action) => {
      return {
        ...state,
        isSaving: action.payload,
      };
    },
    setTestRules: (state, action) => {
      return {
        ...state,
        testRules: {
          ...state.testRules,
          [action.payload.testCaseSetId]: action.payload.testRules,
        },
      };
    },
    setAllVariableSets: (state, action) => {
      return {
        ...state,
        allVariableSets: action.payload || [],
      };
    },
    updateSelectedVariableSetDetail: (state, action) => {
      return {
        ...state,
        selectedVariableSetDetail: { ...action.payload.variableSetDetail },
      };
    },
    setEnvironmentVariableDetails: (state, action) => {
      return {
        ...state,
        selectedEnvironmentVariables: {
          ...action.payload.selectedEnvironmentVariables,
        },
        selectedEnvironmentVariablesJSON:{
          ...action.payload.selectedEnvironmentVariablesJSON,
        }
      };
    },
    setCollectionVariableDetails: (state, action) => {
      return {
        ...state,
        selectedCollectionVariablesJSON: {
          ...action.payload.selectedCollectionVariablesJSON,
        },
      };
    },
    setFolderVariableDetails: (state, action) => {
      return {
        ...state,
        selectedFolderVariablesJSON: {
          ...action.payload.selectedFolderVariablesJSON,
        },
      };
    },
    setIsSaveRequest: (state, action) => {
      return {
        ...state,
        isSaveRequest: action.payload,
      };
    },
    setIsRefetchEnvironment: (state, action) => {
      return {
        ...state,
        isRefetchEnvironment: action.payload,
      };
    },
    setIsRefetchCollection: (state, action) => {
      return {
        ...state,
        isRefetchCollection: action.payload,
      };
    },
    setIsRefetchFolder: (state, action) => {
      return {
        ...state,
        isRefetchFolder: action.payload,
      };
    },
  },
});

export const {
  updateLoadError,
  setLoadingState,
  setSavingState,
  setTestRules,
  setAllVariableSets,
  updateSelectedVariableSetDetail,
  setEnvironmentVariableDetails,
  setCollectionVariableDetails,
  setFolderVariableDetails,
  setIsSaveRequest,
  setIsRefetchEnvironment,
  setIsRefetchCollection,
  setIsRefetchFolder
} = variableSetSlice.actions;

export default variableSetSlice.reducer;
